import { render, staticRenderFns } from "./EditarDispositivoModal.vue?vue&type=template&id=1966d226&"
import script from "./EditarDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports